import * as defaultImport from "@splunk/visualizations/Treemap";
export * from "@splunk/visualizations/Treemap";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
